import * as d3 from 'd3'
export default {
  
  methods: {

    gantt_Chart() {

      let ganttCanvas = this.canvasForm
      .append('g')
      .attr('transform', `translate(${this.gantt.x}, ${this.gantt.y})`)
      
      let y_ = this.gantt.height + 8

      this.rawData.filter(f=> f.DISC !== 'Overall').forEach(d=> {

        let item = ganttCanvas
        .append('g')
        .attr('transform', `translate(0, ${y_})`)
        .style('cursor', 'default').attr('opacity', 1)
        .call(this.call_Pie_Event, d)

        item // Plan
        .append('rect')
        .attr('id', `GANTT_${d.DISC}_${this.localId}`)
        .attr('x', 0).attr('y', -3)
        .attr('width', this.gantt.width + this.timeline.length)
        .attr('height', this.gantt.lineHeight).attr('fill', `#F4F5F5`).attr('opacity', 0)

        this.gantt.columns.forEach(col=> {
          item
          .append('text')
          .attr('x', col.tx).attr('y',  9)
          .attr('font-size', 10)
          .attr('fill', col.code=='DELTA' ? this.gmx_deltaValue(d[col.code]) : col.tColor)
          .attr('text-anchor', col.align)
          .text(col.unit=='%' ? d[col.code]+'%' : d[col.code])
          .call(this.call_Link, col)
        })

        let bar = this.gantt.bar
        item // Plan
        .append('rect')
        .attr('x', this.gantt.width + this.timeline.scale(new Date(d.PS)))
        .attr('y', bar.plan.y)
        .attr('width', this.timeline.scale(new Date(d[bar.plan.pf])) - this.timeline.scale(new Date(d[bar.plan.ps])))
        .attr('height', bar.plan.height).attr('fill', bar.plan.color).attr('opacity', bar.plan.opacity)

        if(d[bar.act.ref]) { 
          item // Actual
          .append('rect')
          .attr('x', this.gantt.width + this.timeline.scale(new Date(d[bar.act.as])))
          .attr('y', bar.act.y)
          .attr('width', d[bar.act.af] ? this.timeline.scale(new Date(d[bar.act.af])) - this.timeline.scale(new Date(d[bar.act.as])) : this.timeline.scale(new Date(this.cutoff)) - this.timeline.scale(new Date(d[bar.act.as])))
          .attr('height', bar.act.height).attr('fill', bar.act.color).attr('opacity', bar.act.opacity)
        }
        y_ += this.gantt.lineHeight
      })
     
    },


    

  }
}